import React, {useState} from "react";
import {PlannerTask} from "../../../../../models/planner/planner";
import {Button, Space} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {PlannerTasksTagAddModal} from "./task.tag.add.modal";
import {TaskTag} from "./task.tag";

interface TaskTagsProps {
    task: PlannerTask
    reload: () => void;
}

export const TaskTags: React.FC<TaskTagsProps> = ({task, reload}) => {

    const [addModalShown, setAddModalShown] = useState<boolean>(false);

    const onComplete = () => {
        setAddModalShown(false);
        reload();
    }

    return (
        <Space direction={"vertical"}>
            {task.tags.map(tag =>
                <TaskTag task={task} tag={tag} reload={reload} />)
            }
            <Button
                icon={<FontAwesomeIcon icon={["fas", "edit"]}/>}
                type={"text"}
                size={"small"}
                onClick={() => setAddModalShown(true)}
            />
            {addModalShown ? (
                <PlannerTasksTagAddModal
                    onClose={onComplete}
                    task={task}
                />
            ) : null}
        </Space>
    )
}
